import { createAction } from 'redux-actions';

export const requestGetTaskTemplateAction = createAction('REQUEST/GET_TASK_TEMPLATE');
export const requestPostTaskTemplateAction = createAction('REQUEST/POST_TASK_TEMPLATE');
export const requestPutTaskTemplateAction = createAction('REQUEST/PUT_TASK_TEMPLATE');
export const requestDeleteTaskTemplateAction = createAction('REQUEST/DELETE_TASK_TEMPLATE');
export const setTaskTemplateDrawerOpenedAction = createAction('SET_TASK_TEMPLATE_DRAWER_OPENED');
export const resetTaskTemplateDataAction = createAction('RESET_TASK_TEMPLATE_DATA_OPENED');
